import React from 'react';

import {
    UpdateCareerGoalSelected,
    OccupationFlowProgressionEvent,
} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {Link} from '@udemy/react-core-components';
import {NewRibbon} from '@udemy/react-messaging-components';

import styles from './personalize-course-unit-props-helper.module.less';

export const personalizeDiscoveryUnitPropData = (
    actionLinkText: string,
    targetLink: string,
    clickEventTracker: UpdateCareerGoalSelected | OccupationFlowProgressionEvent,
    showNewBadge?: boolean,
    showSubtitle?: boolean,
    uiRegion?: string,
) => {
    const subtitle = () => {
        return (
            showSubtitle && (
                <div className={styles['secondary-text']} data-purpose="sub-title">
                    {showNewBadge && <NewRibbon />}
                    <span className="ud-text-xs">{gettext('Inspired by your selections')}</span>
                </div>
            )
        );
    };
    return {
        actionLink: {
            text: actionLinkText,
            buttonProps: {
                componentClass: Link,
                to: targetLink,
                onClick: () => Tracker.publishEvent(clickEventTracker),
            },
        },
        subtitle: subtitle(),
        uiRegion,
    };
};
